import {
  prepareRequest
} from './request'

export const fetchDocuments = (options) => {
  const request = prepareRequest({
    method: 'GET',
    url: 'client/client/documents'
  })

  return request(options)
}

export const uploadDocument = (options) => {
  const request = prepareRequest({
    method: 'POST',
    url: 'client/client/documents:upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return request(options)
}
